import { Component, ChangeDetectionStrategy } from '@angular/core';
import { EditorComponentBase, SlideToggleComponent } from 'ngx-lib';

@Component({
    selector: 'app-include-archived-editor',
    templateUrl: './include-archived-editor.component.html',
    styleUrls: ['./include-archived-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SlideToggleComponent]
})
export class IncludeArchivedEditorComponent extends EditorComponentBase<boolean> {
    constructor() {
        super();
    }

    onToggleChanged(value: boolean): void {
        this.bindingProperty = value;
        this.valueChange.emit();
    }
}
